var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 2.125C1.25 1.504 1.754 1 2.375 1H8.375C8.996 1 9.5 1.504 9.5 2.125V5.875C9.5 6.496 8.996 7 8.375 7H2.375C2.07663 7 1.79048 6.88147 1.5795 6.6705C1.36853 6.45952 1.25 6.17337 1.25 5.875V2.125ZM13.25 3.625C13.25 3.004 13.754 2.5 14.375 2.5H19.625C20.246 2.5 20.75 3.004 20.75 3.625V11.875C20.75 12.496 20.246 13 19.625 13H14.375C14.0766 13 13.7905 12.8815 13.5795 12.6705C13.3685 12.4595 13.25 12.1734 13.25 11.875V3.625ZM2.75 11.125C2.75 10.504 3.254 10 3.875 10H9.125C9.746 10 10.25 10.504 10.25 11.125V13.375C10.25 13.996 9.746 14.5 9.125 14.5H3.875C3.57663 14.5 3.29048 14.3815 3.0795 14.1705C2.86853 13.9595 2.75 13.6734 2.75 13.375V11.125Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.822b08c2ec97f317d499e283803c8417.svg";
export { ForwardRef as ReactComponent };